import { useEffect, useState } from "react";
import { useHandleClickVideo } from "./useHandleClickVideo";
import { useAutoShowActionBar } from "./useAutoShowActionBar";

export const useManageControl = (videoRef, actionBarRef, wrapperRef, props) => {
  const { autoPlay, muted } = props;
  const [playingStatus, setPlayingStatus] = useState(
    autoPlay && muted ? "play" : "pause"
  );
  const [hideBar, setHideBar] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const { handleClick, handleDoubleClick } = useHandleClickVideo(
    videoRef,
    wrapperRef,
    setIsFullScreen,
    props
  );
  useAutoShowActionBar(props, actionBarRef, setHideBar);

  /* c8 ignore next 15 */
  useEffect(() => {
    const playerRef = videoRef.current;
    if (!playerRef) return;
    const setPlay = () => {
      setPlayingStatus("play");
    };
    const setPause = () => {
      setPlayingStatus("pause");
    };
    playerRef.addEventListener("play", setPlay, []);
    playerRef.addEventListener("pause", setPause, []);
    return () => {
      playerRef.removeEventListener("play", setPlay);
      playerRef.removeEventListener("pause", setPause);
    };
  }, [videoRef.current]); //eslint-disable-line
  useEffect(() => {
    if (!isFullScreen) {
      setHideBar(false);
    }
  }, [isFullScreen]);
  return {
    playingStatus,
    setPlayingStatus,
    hideBar,
    isFullScreen,
    setIsFullScreen,
    handleClick,
    handleDoubleClick,
  };
};
